import { render } from "./pre-text.vue?vue&type=template&id=3181b310&scoped=true&ts=true"
import script from "./pre-text.vue?vue&type=script&lang=ts"
export * from "./pre-text.vue?vue&type=script&lang=ts"

import "./pre-text.vue?vue&type=style&index=0&id=3181b310&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3181b310"]])

export default __exports__